import type { IEntityResponse } from '../response'

export enum BabyNotificationType {
  FOOD = 'Food',
  SLEEP = 'Sleep',
}

interface IBabyNotification {
  id: number
  tag: BabyNotificationType
  time: { hours: number | string; minutes: number | string }
  isEnabled: boolean
}

type NotificationResponse = IEntityResponse<IBabyNotification[]>

export type { IBabyNotification, NotificationResponse }
